export default __webpack_public_path__ + "static/media/Safe-White.87e1ef0d.png";